// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// RxJS
// CRUD
import { HttpUtilsService } from '../../_base/crud';
// Models

// Ngrx
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth/_selectors/auth.selectors';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SpecialtyService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  searchProviderTypes(val = '', filter = '') {
    const url =
      environment.CORE_BASE +
      `/companies/${this.company_id}/doctors/provider_types?term=${val}${filter}`;
    return this.http.get<any>(url);
  }

  getProviderTypesByIds(ids: number[]) {
    let fromString = '';
    ids.forEach((id) => (fromString += `&id=${id}`));
    const params = new HttpParams({ fromString });
    return this.http.get<any>(
      `${environment.CORE_BASE}/companies/${this.company_id}/provider-types/get-by-ids`,
      { params },
    );
  }
}
